import React, { memo } from "react";
import { Trans, useTranslation } from "@tecma/i18n";
import { Button } from "@tecma/ds";
import "./banner-mobile.scss";
import { currencyFormatter } from "utils/currency";

interface BannerMobileProps {
  price: number;
  onButtonClick: () => void;
  buttonLabel: string;
  startDate?: string;
  endDate?: string;
}
// TODO: remove static dates
const BannerMobile: React.FC<BannerMobileProps> = ({
  price,
  onButtonClick,
  buttonLabel,
  startDate = "1 Gen 24",
  endDate = "1 Gen 28",
}) => {
  const { t } = useTranslation();
  const formattedPrice = currencyFormatter(price || 0, "EUR", {
    style: "decimal",
    maximumFractionDigits: 2,
  });
  return (
    <div className='banner-mobile'>
      <div className='banner-mobile__content'>
        <div className='banner-mobile__price-dates'>
          <span className='banner-mobile__price'>
            <span className='price '>
              <span className='banner-mobile__per-month'>
                <Trans
                  i18nKey='details-page.banner-mobile.per-month'
                  values={{
                    count: formattedPrice,
                  }}
                />
              </span>
            </span>
          </span>
          <span className='banner-mobile__taxes'>
            {t("card-rooms.feature.taxes")}
          </span>
          <span className='banner-mobile__dates'>
            {startDate} - {endDate}
          </span>
        </div>
        <Button onClick={onButtonClick}>{buttonLabel}</Button>
      </div>
    </div>
  );
};

export default memo(BannerMobile);
